export default __webpack_public_path__ + "media/images/indent-left-black-76d1a9345b90c755ed9ea48e87995ad4.png";